import { createSelector } from '@ngrx/store'
import { selectSalaryComponentsState } from './salary-components.reducers'
import { SalaryComponentsState } from './salary-components.state'

export const selectSalaryComponents = (componentType: string) =>
  createSelector(selectSalaryComponentsState, (state: SalaryComponentsState) => {
    return state.salaryComponents[componentType]
  })
